/**
 * Ürün adından ve özelliklerinden filtrelenebilir nitelikler çıkarır.
 * Veri dosyalarına ayrı alan eklemeden çalışır: "DeWalt DCD796 18V XR ..." → voltaj 18V.
 * Kategori sayfasındaki filtreler ve ürün karşılaştırma bu fonksiyonları kullanır.
 */

export const RENKLER = [
  "Beyaz", "Siyah", "Gri", "Antrasit", "Krem", "Kahverengi", "Kırmızı", "Mavi", "Lacivert",
  "Yeşil", "Sarı", "Turuncu", "Mor", "Pembe", "Şeffaf", "Krom", "Altın", "Bakır", "Bej", "Füme",
];
const RENK_RE = new RegExp(`(?:^|[\\s/(-])(${RENKLER.join("|")})(?=$|[\\s/),-])`, "g");

const voltajBul = (ad) => {
  const m = ad.match(/\b(10[.,]8|12|18|36|54)\s?V\b/i);
  return m ? `${m[1].replace(".", ",")}V` : null;
};

const akuDurumu = (u) => {
  const o = (u.ozellikler || []).join(" ");
  if (/gövde \(akü/i.test(o)) return "govde";
  if (/akü dahil/i.test(o)) return "akulu";
  return null;
};

const renkleriBul = (u) => {
  const bulunan = new Set();
  for (const m of u.ad.matchAll(RENK_RE)) bulunan.add(m[1]);
  for (const b of u.boyutlar || []) if (RENKLER.includes(b)) bulunan.add(b);
  return [...bulunan];
};

// Ölçü/ambalaj seçenekleri: renk olmayan "boyutlar" değerleri (15 L, 10 mm, 1 Adet …)
const secenekleriBul = (u) => (u.boyutlar || []).filter((b) => !RENKLER.includes(b));

/** Bir ürünün filtrelenebilir nitelikleri: { voltaj: [...], aku: [...], renk: [...], secenek: [...] } */
export const nitelikler = (u) => {
  const v = voltajBul(u.ad);
  const a = akuDurumu(u);
  return {
    voltaj: v ? [v] : [],
    aku: a ? [a] : [],
    renk: renkleriBul(u),
    secenek: secenekleriBul(u),
  };
};

export const NITELIK_SIRASI = ["voltaj", "aku", "renk", "secenek"];

const sayisalSira = (a, b) => {
  const na = parseFloat(String(a).replace(",", "."));
  const nb = parseFloat(String(b).replace(",", "."));
  if (!Number.isNaN(na) && !Number.isNaN(nb) && na !== nb) return na - nb;
  return String(a).localeCompare(String(b), "tr");
};

/**
 * Ürün listesinden filtre grupları üretir. Tek değerli ya da çok dağınık gruplar (ör. 40 farklı ölçü) gösterilmez.
 * Dönüş: [{ anahtar, degerler: [[deger, adet], ...] }]
 */
export const filtreGruplari = (urunler) => {
  const say = { voltaj: new Map(), aku: new Map(), renk: new Map(), secenek: new Map() };
  for (const u of urunler) {
    const n = nitelikler(u);
    for (const k of NITELIK_SIRASI) for (const d of n[k]) say[k].set(d, (say[k].get(d) || 0) + 1);
  }
  return NITELIK_SIRASI.map((anahtar) => ({
    anahtar,
    degerler: [...say[anahtar].entries()].sort((a, b) => (anahtar === "renk" ? b[1] - a[1] : sayisalSira(a[0], b[0]))),
  })).filter((g) => g.degerler.length >= 2 && g.degerler.length <= 30);
};

/** Seçili filtrelere uyuyor mu? Grup içinde VEYA, gruplar arasında VE. */
export const filtreyeUyar = (u, secili) => {
  const aktif = Object.entries(secili).filter(([, d]) => d.length);
  if (!aktif.length) return true;
  const n = nitelikler(u);
  return aktif.every(([k, d]) => n[k]?.some((x) => d.includes(x)));
};

/** Sıralama: "onerilen" (veri sırası), "az", "za", "marka" */
export const sirala = (liste, tur) => {
  if (tur === "az") return [...liste].sort((a, b) => a.ad.localeCompare(b.ad, "tr"));
  if (tur === "za") return [...liste].sort((a, b) => b.ad.localeCompare(a.ad, "tr"));
  if (tur === "marka") return [...liste].sort((a, b) => a.marka.localeCompare(b.marka, "tr") || a.ad.localeCompare(b.ad, "tr"));
  return liste;
};
